import { createSelector } from '@reduxjs/toolkit';

// Basic selectors
export const selectActivePatientState = (state) => state.activePatient;

export const selectActivePatientUuid = (state) => state.activePatient.patientUuid;

export const selectActivePatientInfo = (state) => state.activePatient.patientInfo;

// Computed selectors
export const selectHasActivePatient = createSelector(
  [selectActivePatientUuid],
  (patientUuid) => !!patientUuid
);

export const selectActivePatientFullName = createSelector(
  [selectActivePatientInfo],
  (patientInfo) => {
    if (!patientInfo) return null;
    const { firstName, lastName } = patientInfo;
    return firstName || lastName ? `${firstName || ''} ${lastName || ''}`.trim() : null;
  }
);

export const selectActivePatientDisplayInfo = createSelector(
  [selectActivePatientInfo, selectActivePatientFullName],
  (patientInfo, fullName) => ({
    ...patientInfo,
    fullName,
    hasInfo: !!patientInfo,
  })
);

// Export combined state for context replacement
export const selectActivePatientContext = createSelector(
  [selectActivePatientUuid, selectActivePatientInfo],
  (patientUuid, patientInfo) => ({
    patientUuid,
    patientInfo,
  })
);